import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ImageViewerController } from 'ionic-img-viewer';
import { ModalVideoComponent } from '../../components/modal-video/modal-video';
import { VideoPlayerPage } from '@pages';
import { Platform } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { MaterialesApoyoProvider } from '@providers/materiales-apoyo/materiales-apoyo';
import { AuthProvider } from '@providers/auth/auth';
import { LoadingController } from 'ionic-angular';
import { LoadingProvider } from '@providers/loading/loading';

@IonicPage()
@Component({
  selector: 'page-material-apoyo-detalle',
  templateUrl: 'material-apoyo-detalle.html',
})
export class MaterialApoyoDetallePage {

  jugador: any;
  equipo: any;
  _imageViewerCtrl: ImageViewerController;
  material: any;
  esMarcadoComoVisto: boolean;
  isLiked: any;
  @ViewChild(ModalVideoComponent) modalVideo: ModalVideoComponent;
  @ViewChild('audioPlayer') audioPlayer: ElementRef;
  @ViewChild('like') like: ElementRef;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public platform: Platform,
    public iab: InAppBrowser,
    imageViewerCtrl: ImageViewerController,
    public materialesApoyoProvider: MaterialesApoyoProvider,
    public authProvider: AuthProvider,
    public loadingCtrl: LoadingController,
    public loadingProvider: LoadingProvider,
  ) {
    this._imageViewerCtrl = imageViewerCtrl;
    this.material = this.navParams.get('material');

    this.material.tags = this.material.tags.filter(t => t);
  }

  async ionViewDidLoad() {
    this.jugador = await this.authProvider.getSession();
    this.equipo = await this.authProvider.getEquipo();

    const response = await this.materialesApoyoProvider.isLiked(this.equipo.area._id, this.jugador._id, this.material._id);
    this.isLiked = response;

    if(this.material.tipo == 'TEXTO') {
      this.marcarComoVisto();
    }
    
    if(this.material.tipo == 'AUDIO') {
      const vid = this.audioPlayer.nativeElement;
      vid.onplay = () => {
        if(!this.esMarcadoComoVisto) {
          this.esMarcadoComoVisto = true;
          this.marcarComoVisto();
        }
        
      };
    }
  }

  close() {
    this.navCtrl.pop();
  }

  showImage(img) {
    const imageViewer = this._imageViewerCtrl.create(img);
    imageViewer.present();

    this.marcarComoVisto();
  }

  async showVideo() {
    const loader = this.loadingCtrl.create();
    loader.present();

    const response = await this.materialesApoyoProvider.getOne(this.material._id);

    await this.navCtrl.push(VideoPlayerPage, {
      material: response
    });
    
    loader.dismiss();

    this.marcarComoVisto();
  }

  async openPDF() {
    this.loadingProvider.show(true);

    const response = await this.materialesApoyoProvider.getOne(this.material._id);
    const browser = this.iab.create(response.url, '_system');
    browser.show();

    this.loadingProvider.show(false);

    this.marcarComoVisto();
  }

  async marcarComoVisto() {
    await this.materialesApoyoProvider.marcarComoVisto(this.equipo.area._id, this.jugador._id, this.material._id);
    
    if( this.isLiked.like == null ) {
      this.isLiked = {
        like: false
      };
    }
    
  }


  async handleLike() {   
    const response = await this.materialesApoyoProvider.like(this.equipo.area._id, this.jugador._id, this.material._id);
    this.isLiked = response;
    
    this.like.nativeElement.classList.add("animated", "rubberBand");

    let animationEnd = (function(el) {
      let animations = {
        animation: 'animationend',
        OAnimation: 'oAnimationEnd',
        MozAnimation: 'mozAnimationEnd',
        WebkitAnimation: 'webkitAnimationEnd',
      };

      for (let t in animations) {
        if (el.style[t] !== undefined) {
          return animations[t];
        }
      }
    })(document.createElement('div'));

    this.like.nativeElement.addEventListener(animationEnd, () => {
      this.like.nativeElement.classList.remove("animated",  "rubberBand" );
    });

    
  }

}



// WEBPACK FOOTER //
// ./src/pages/material-apoyo-detalle/material-apoyo-detalle.ts